import { LineController } from "chart.js";

class ShadowLineChart extends LineController {
  draw() {
    super.draw(arguments);

    const ctx = this.chart.ctx;
    const _stroke = ctx.stroke;
    ctx.stroke = function() {
      ctx.save();
      ctx.shadowColor = "rgba(0.1, 0.1, 0.1, 0.2)";
      ctx.shadowBlur = 8;
      ctx.shadowOffsetX = 2;
      ctx.shadowOffsetY = 8;

      _stroke.apply(this, arguments);
      ctx.restore();
    };
  }
}

ShadowLineChart.id = "shadowLine";
ShadowLineChart.defaults = LineController.defaults;

export default ShadowLineChart;
